<div [matMenuTriggerFor]="menu"></div>
<mat-menu #menu="matMenu">
  <div class="menu-container">
    @for (team of teams$ | async; track teamTrackBy($index, team)) {
      <button
        mat-menu-item
        class="option"
        data-testid="roles-team-option"
        [attr.data-team-id]="team.id"
        (click)="handleTeamClicked(team)"
      >
        <div class="content-wrapper">
          <div class="start-content">
            <div class="mat-body-strong truncate">{{ team.name }}</div>
            <div class="mat-caption description">
              @if (team.memberOnCall?.user?.userId) {
                <app-basic-celo-avatar
                  [userId]="team.memberOnCall.user.userId"
                  [name]="
                    $safeNavigationMigration(team.memberOnCall?.user?.fullName)
                  "
                  [size]="12"
                ></app-basic-celo-avatar>
              }
              <div class="truncate">
                {{
                  team.isCurrentUserOnCall
                    ? "You are on call"
                    : team.memberOnCall?.user?.firstName
                      ? team.memberOnCall.user.firstName + " is on call"
                      : "No one is clocked in"
                }}
              </div>
            </div>
          </div>
          @if (team.unreadConversationIds?.length) {
            <div class="end-content">
              {{ team.unreadConversationIds.length }}
            </div>
          }
        </div>
      </button>
    }
  </div>
</mat-menu>
